//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiDotsVertical } from '@mdi/js'

export default {
  setup() {
    const socialAnalytics = [
      {
        avatar: require('@/assets/images/pages/heart-medical.png'),
        color: 'primary',
        title: '42.8k',
        subtitle: 'Number of like',
      },
      {
        avatar: require('@/assets/images/pages/graph-bar.png'),
        color: 'warning',
        title: '21.2k',
        subtitle: 'Number of Followers',
      },
      {
        avatar: require('@/assets/images/pages/comment-alt-lines.png'),
        color: 'info',
        title: '2.4k',
        subtitle: 'Number of Comments',
      },
      {
        avatar: require('@/assets/images/pages/user.png'),
        color: 'success',
        title: '389.50k',
        subtitle: 'Number of Visits',
      },
    ]

    return {
      socialAnalytics,
      icons: {
        mdiDotsVertical,
      },
    }
  },
}
